import loggingService from 'common/logging/loggingService';
import useStartup from 'common/ui/useStartup';
import React, { useState } from 'react';
import ConfirmationModal, { useConfirmationModal } from "common/ui/ConfirmationModal";
import ValidationError from "common/validationError";
import MerchantDetailsComponentProps from '../merchantDetailsComponentProps';
import Role from "admin/features/roles/role";
import roleService from "admin/features/roles/rolesService";
import UserRoleAssignment from "admin/features/roles/userRoleAssignment";
import UserRoleAssignmentList from "admin/features/roles/UserRoleAssignmentList";
import AddUserRoleAssignmentModal from "admin/features/roles/AddUserRoleAssignmentModal";
import SystemUser from "admin/features/roles/systemUser";

const RoleSettings: React.FC<MerchantDetailsComponentProps> = props => {
    const [assignments, setAssignments] = useState<UserRoleAssignment[]>(null);
    const [errors, setErrors] = useState<string[]>(null);
    const [showAddModal, setShowAddModal] = useState(false);

    const confirmRemove = useConfirmationModal();

    async function onAddRole(user: SystemUser, role: Role) {
        try {
            setErrors(null);
            await roleService.addUserToRole(role.id, user.userId, props.merchant.id);

            const newAssignment: UserRoleAssignment = {
                user: {
                    userId: user.userId,
                    name: `${user.firstName} ${user.lastName}`
                },
                role: role,
                merchant: {
                    id: props.merchant.id,
                    name: props.merchant.name
                }
            };

            setAssignments([...assignments, newAssignment]);
            setShowAddModal(false);
        }
        catch (err) {
            setErrors((err as ValidationError).errors ?? ["An unknown error occurred"]);
        }
    }

    function removeUserFromRole(userRoleAssignment: UserRoleAssignment) {
        confirmRemove.show(
            "Remove User From Role?",
            `Are you sure you want to remove ${userRoleAssignment.user.name} from ${userRoleAssignment.role.name} role?`,
            async () => {
                    await roleService.removeUserFromRole(userRoleAssignment.role.id, userRoleAssignment.user.userId, userRoleAssignment.merchant.id);
                    setAssignments(assignments.filter(m => m.user.userId !== userRoleAssignment.user.userId ||
                        m.role.id !== userRoleAssignment.role.id));
            })
    }

    useStartup(() => {
        roleService.listUserRolesForMerchant(props.merchant.id)
            .then(setAssignments)
            .catch(err => {
                loggingService.error("Unable to retrieve assignments", err);
            });
    });

    return <div>
        <UserRoleAssignmentList
            assignments={assignments}
            showRoleColumn
            showAddAssignment
            headerText="Roles"
            addButtonText="Add User Role"
            onShowAddAssignment={() => setShowAddModal(true)}
            onRemoveAssignment={removeUserFromRole}
        />

        <AddUserRoleAssignmentModal
            forMerchant={props.merchant}
            showUser
            showRole
            show={showAddModal}
            errors={errors}
            onHide={() => setShowAddModal(false)}
            onAdd={(u, m, r) => onAddRole(u, r)}
        />

        <ConfirmationModal modalState={confirmRemove.state} />
    </div>;
}

export default RoleSettings;